import Button from '@insided/control/uikit/Button'

/* eslint-disable import/no-internal-modules */
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@insided/deprecated-preact-components/modal'

interface ResolveModalProps {
  onResolve: () => void
  onClose: () => void
}
const ResolveModal = ({ onResolve, onClose }: ResolveModalProps) => {
  return (
    <Modal isOpen size='medium'>
      <ModalHeader title='Resolve reported content' onClose={onClose} />
      <ModalBody>The selected report(s) will not be shown on the topic page anymore.</ModalBody>
      <ModalFooter>
        <Button title='Resolve' variant='success' onClick={() => onResolve()} size='medium' />
        <Button title='Cancel' onClick={onClose} size='medium' />
      </ModalFooter>
    </Modal>
  )
}
export default ResolveModal
